module.exports = __webpack_public_path__ + "static/media/ka-rotate-poster.52fd1c1f.png";